﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDashboard = void 0;
const PriceKeeperView_1 = require("../com/contractViews/PriceKeeperView");
const com = require("../com/tmpls");
const UpManagerView_1 = require("../com/contractViews/UpManagerView");
const StatePaged_1 = require("./abstracts/StatePaged");
const BuyBurnPoolView_1 = require("../com/contractViews/BuyBurnPoolView");
const LiquidControllerView_1 = require("../com/contractViews/LiquidControllerView");
const StabilityPoolView_1 = require("../com/contractViews/StabilityPoolView");
const InternalExchangerBnBView_1 = require("../com/contractViews/InternalExchangerBnBView");
const InternalExchangerSPView_1 = require("../com/contractViews/InternalExchangerSPView");
const UPTokenView_1 = require("../com/contractViews/UPTokenView");
const ERC20Contract_1 = require("../contracts/ERC20Contract");
class StateDashboard extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageDashboard, "uPX ecosystem dashboard", true, false);
        this._geekClickCounter = 0;
        this._statsViews = [];
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.gui.showPage(this.page);
            const blockPrices = new com.CmpBlockPriceKeepers();
            this.page.ctrls.blocks.append(blockPrices);
            this._priceKeeperViewPLS = new PriceKeeperView_1.PriceKeeperView(this.app.chain.priceKeeperPLS, "USD");
            this._priceKeeperViewPLS.refresh();
            blockPrices.ctrls.blockPrices.append(this._priceKeeperViewPLS);
            this._priceKeeperViewUp = new PriceKeeperView_1.PriceKeeperView(this.app.chain.priceKeeperUP, "USDL");
            this._priceKeeperViewUp.refresh();
            blockPrices.ctrls.blockPrices.append(this._priceKeeperViewUp);
            const blockUpTotal = new UPTokenView_1.UPTokenView(new ERC20Contract_1.ERC20Contract(this.app.chain.addressTokenUP, this.app.chain.web3), this.app.chain.burnableUp);
            blockUpTotal.refresh();
            this.page.ctrls.blocks.append(blockUpTotal);
            const blockUpManager = new UpManagerView_1.UpManagerView(this.app.chain.upManager);
            this.page.ctrls.blocks.append(blockUpManager);
            blockUpManager.ctrls.imgLogo.onclick = () => this.initGeekAreaAsync();
            yield this.feelStatsAsync();
            if (globalThis.showChart) {
                const blockChart = new com.CmpBlockChart();
                this.page.ctrls.blocks.append(blockChart);
                globalThis.showChart('1hour');
            }
            return _super.start.call(this);
        });
    }
    initGeekAreaAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._geekClickCounter++;
            if (this._geekClickCounter != 5)
                return;
            const blockExchangers = new com.CmpBlockInternalExchangers();
            let internalExchangerBnB = new InternalExchangerBnBView_1.InternalExchangerBnBView(this.app.chain.internalExchangerBnB);
            blockExchangers.ctrls.blockExchangers.append(internalExchangerBnB);
            internalExchangerBnB.refresh();
            let internalExchangerSP = new InternalExchangerSPView_1.InternalExchangerSPView(this.app.chain.internalExchangerSP);
            blockExchangers.ctrls.blockExchangers.append(internalExchangerSP);
            internalExchangerSP.refresh();
            this.page.ctrls.blocks.append(blockExchangers);
            const blockPools = new com.CmpBlockPools();
            let bbPool = new BuyBurnPoolView_1.BuyBurnPoolView(this.app.chain.buyBurnPool);
            blockPools.ctrls.blockPools.append(bbPool);
            bbPool.refresh();
            let stabPool = new StabilityPoolView_1.StabilityPoolView(this.app.chain.stabilityPool);
            blockPools.ctrls.blockPools.append(stabPool);
            stabPool.refresh();
            this.page.ctrls.blocks.append(blockPools);
            const blockContactsVaults = new com.CmpBlockContracts();
            this.page.ctrls.blocks.append(blockContactsVaults);
            for (const vc of this.app.chain.liquidControllers) {
                let vault = new LiquidControllerView_1.LiquidControllerView(vc);
                blockContactsVaults.ctrls.blockContainer.append(vault);
                vault.refresh();
            }
        });
    }
    feelStatsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ef = (e, d = 3) => this._ethToFormat(e + "", d);
            const blockStats = new com.CmpBlockStatsContainer();
            this.page.ctrls.blocks.append(blockStats);
            const addStatFunc = (header, text, desc) => {
                let stat = new com.CmpStatsItem();
                stat.ctrls.lHeader.text = header;
                stat.ctrls.lText.text = text;
                stat.ctrls.lDescription.text = desc;
                blockStats.ctrls.blockContainer.append(stat);
                stat.onclick = () => {
                    if (stat.ctrls.lText.hasClass('hidden')) {
                        stat.ctrls.lText.removeClass('hidden');
                        stat.ctrls.lDescription.addClass('hidden');
                    }
                    else {
                        stat.ctrls.lText.addClass('hidden');
                        stat.ctrls.lDescription.removeClass('hidden');
                    }
                };
                this._statsViews.push(stat);
                return stat;
            };
            const bnbStats = yield this.app.chain.buyBurnPool.getStatistics();
            const spStakedLoan = yield this.app.chain.stabilityPool.getStakedLOAN();
            const spStakedUSDL = yield this.app.chain.stabilityPool.getStakedUSDL();
            const spATHPrice = yield this.app.chain.stabilityPool.getPricePLS_ATH();
            const bbpStakedLoan = yield this.app.chain.buyBurnPool.getStakedLOAN();
            const bbpStakedUSDL = yield this.app.chain.buyBurnPool.getStakedUSDL();
            const bbpATHPrice = yield this.app.chain.buyBurnPool.getPriceATH();
            let bwAsset = 0;
            let nextLoanStatItem;
            // State
            addStatFunc("State", "Working", "Current state of the uPX ecosystem contracts.");
            // Last Buy
            {
                var date = new Date(parseFloat(bnbStats.lastBoughtTimestamp) * 1000);
                let dateString = "";
                if (parseFloat(bnbStats.lastBoughtAmountUSDL) != 0) {
                    const month = date.toLocaleString('default', { month: 'long' });
                    dateString = `\n${month.charAt(0).toUpperCase() + month.slice(1)} ${date.getDate()} ${date.getFullYear()}`;
                }
                addStatFunc("Loan & Stake Last Buy", `${this._ethToFormat(bnbStats.lastBoughtAmountUSDL)} USDL\n${dateString}`, "Last Buy amount, including reloan and staking rewards. Below is the date when the buy happened.");
            }
            // Total of B&B Pool
            {
                let upPrice = parseFloat(this._priceKeeperViewUp.getLastPrice());
                let totalUp = parseFloat(bnbStats.totalBurnUp);
                let burnedIndex = parseFloat(bnbStats.totalBurnUp) / 51869006448;
                addStatFunc("Loan & Stake B&B", `uPX Burned:\n${this._ethToFormat(bnbStats.totalBurnUp)} (${this._ethToFormat(burnedIndex * 100 + "", 1)}%)\nUSDL spent: ${this._ethToFormat(bnbStats.totalBoughtAmountUSDL)} USD`, "Total amount includes the total amount of USDL sold for uPX, amount of uPX burned, and the value of the burned amount at the current price of uPX.");
            }
            //Next Loan
            {
                nextLoanStatItem = addStatFunc("Next Loan", "", "Price of Pulse needed to take out the next loan for Buy and Burn.");
            }
            //************************************************//
            let nextLoanPrice = 0;
            let vaultId = 0;
            for (const v of this.app.chain.liquidControllers) {
                vaultId++;
                let conf = yield v.getConfig();
                let coll = yield v.getColl();
                let debt = yield v.getDebt();
                let plsPrice = parseFloat(this._priceKeeperViewPLS.getLastPrice());
                let collPriced = parseFloat(coll) * plsPrice + "";
                bwAsset += parseFloat(collPriced) - parseFloat(debt);
                let icr = parseFloat(collPriced) / parseFloat(debt);
                let sm = 1.1 / icr;
                let liqPrice = 1.1 / icr * plsPrice;
                let nLoanPrice = parseFloat(conf.targetReloanICR) / icr * plsPrice;
                if (nextLoanPrice == 0 || nextLoanPrice > nLoanPrice)
                    nextLoanPrice = nLoanPrice;
                let targetICR = Math.round(parseFloat(conf.targetReloanICR) * 1000) / 10 + ""; // parseInt(+"")/10;
                addStatFunc("Vault " + vaultId, `ICR: ${this._ethToFormat(icr * 100 + "")}%\n Target ICR: ${targetICR}%`, "Vault's current ICR and the ICR setting for when to take out the next loan.");
                addStatFunc("Collateral", `${this._ethToFormat(coll)} PLS\n ${this._ethToFormat(collPriced)} USD`, "Vault collateral level in Pulse and its value at the current price of PLS.");
                addStatFunc("Total Loan", `${this._ethToFormat(debt)} USDL`, "Total amount of the loan taken out from the vault.");
                addStatFunc("Liquidation", `PLS price: ${this._ethToFormat(liqPrice + "")} USD\nSafety Margin: ${this._ethToFormat((100 - sm * 100) + "")}%`, "Liquidation price of PLS required to liquidate the vault with a price safety margin - the percentage drop in the price of PLS needed to reach the 110 ICR.");
            }
            if (nextLoanPrice != 0 && nextLoanStatItem != null) {
                nextLoanStatItem.ctrls.lText.text = `PLS price: ${this._ethToFormat(nextLoanPrice + "")} USD`;
            }
            //************************************************//
            //Stability Pool
            {
                addStatFunc("Stability Pool", `Staked:\n ${this._ethToFormat(spStakedUSDL)} USDL\n${this._ethToFormat(spStakedLoan)} LOAN`, "Total amount of staked assets in the Stability Pool in USDL and LOAN.");
                bwAsset += parseFloat(spStakedUSDL);
            }
            //Buy&Burn Pool
            {
                let halfATHPrice = parseFloat(bbpATHPrice) / 2 + '';
                addStatFunc("Buy & Burn Pool", `ATH/2 PLS price: ${this._ethToFormat(halfATHPrice)} USD\nStaked:\n ${this._ethToFormat(bbpStakedUSDL)} USDL\n${this._ethToFormat(bbpStakedLoan)} LOAN`, "Total amount of staked assets in the Buy and Burn Pool in USDL and LOAN.");
                bwAsset += parseFloat(bbpStakedUSDL);
            }
            //BW Assets
            {
                addStatFunc("BWX Assets", `~ ${this._ethToFormat(bwAsset + "")} USD\nPumping uPX`, "Current value of assets to pump uPX.");
            }
            //New Vault
            {
                addStatFunc("New Vault", `PLS price: ${this._ethToFormat(parseFloat(spATHPrice) * 0.35 + "")} USD`, "Price point of PLS to open a new vault.");
            }
            //************************************************//
            let validatorsCount = yield this.app.chain.validatorsManager.getValidatorsCount();
            if (!validatorsCount)
                validatorsCount = 0;
            const stakePerValidator = 32000000;
            const validatorsStakedTotal = validatorsCount * stakePerValidator;
            //Validators
            {
                addStatFunc("Validators", `Online: ${validatorsCount}\n Staked:\n ${ef(validatorsStakedTotal)} PLS`, "Total number of validators online with staked PLS amount.");
            }
            //Validator Yield
            {
                const totalIncomePLS = yield this.app.chain.validatorsStats.getTotalIncomePLS();
                const stats = yield this.app.chain.validatorsStats.getStatsFromEnd(0);
                while (true) {
                    if (stats.list.length == 0)
                        break;
                    const last = stats.list.pop();
                    if (last.timestamp == "0")
                        continue;
                    stats.list.push(last);
                    break;
                }
                if (stats.list.length > 0)
                    stats.list.pop(); //извлекаем первую неделю
                let weekAcc = 0;
                let weekIndex = 0;
                let monthAcc = 0;
                let monthIndex = 0;
                let yearAcc = 0;
                let yearIndex = 0;
                let i = 0;
                for (let stat of stats.list) {
                    i++;
                    if (i <= 1) {
                        weekAcc += parseFloat(stat.acc);
                        weekIndex += parseFloat(stat.profitPerValidator);
                    }
                    if (i <= 4) {
                        monthAcc += parseFloat(stat.acc);
                        monthIndex += parseFloat(stat.profitPerValidator);
                    }
                    if (i <= 52) {
                        yearAcc += parseFloat(stat.acc);
                        yearIndex += parseFloat(stat.profitPerValidator);
                    }
                }
                if (i < 4) {
                    monthAcc = monthAcc / i / 7 * 30;
                    monthIndex = monthIndex / i / 7 * 30;
                }
                if (i < 52) {
                    yearAcc = yearAcc / i * 52;
                    yearIndex = yearIndex / i * 52;
                }
                weekIndex = parseInt(weekIndex / 32000000 * 10000 + "") / 100;
                monthIndex = parseInt(monthIndex / 32000000 * 1000 + "") / 10;
                yearIndex = parseInt(yearIndex / 32000000 * 1000 + "") / 10;
                let message = `Week: Calculating\nTotal: ${ef(totalIncomePLS, 0)} PLS`;
                if (weekIndex > 0)
                    message = `Week: ${ef(weekAcc, 0)} PLS (${weekIndex}%)\nMonth: ${ef(monthAcc, 0)} PLS (${monthIndex}%)\nYear: ${ef(yearAcc, 0)} PLS (${yearIndex}%)\nTotal: ${ef(totalIncomePLS, 0)} PLS`;
                addStatFunc("Validator Yield", message, "Factual yield from validators online for the last known period, projects potential yield for longer periods.");
            }
            //Validator B&B
            {
                const stats = yield this.app.chain.validatorsBnB.getStatistic();
                const lastSwapPLS = stats.lastSwapAmountPLS;
                const spentPLS = stats.totalSwapAmountPLS;
                const bnbUp = stats.totalBurnUp;
                var date = new Date(parseFloat(stats.lastSwapTimestamp) * 1000);
                let dateString = "";
                if (parseFloat(lastSwapPLS) != 0) {
                    const month = date.toLocaleString('default', { month: 'long' });
                    dateString = `${month.charAt(0).toUpperCase() + month.slice(1)} ${date.getDate()} ${date.getFullYear()}`;
                }
                addStatFunc("Validator & LPX B&B", `Last B&B: ${ef(lastSwapPLS)} PLS\n${dateString}\nBurned:${ef(bnbUp)} uPX\nSpent: ${ef(spentPLS)} PLS`, "Last buy and burn amount with date, total uPX burned and total PLS spent from validator & LPX yield.");
            }
            //New Validator
            {
                let toNewValidator = parseFloat(yield this.app.chain.validatorsManager.getToValidatorsPLS());
                while (toNewValidator > 32000000)
                    toNewValidator = toNewValidator - 32000000;
                toNewValidator = 32000000 - toNewValidator;
                addStatFunc("New Validator", `PLS to new: ${ef(toNewValidator + "")} PLS`, "Validator yield accumulates to get more validators online. Each key associated with a validator requires locking 32,000,000 PLS to be activated. New validator incoming when PLS to new: 0 PLS.");
            }
            this._startAnimationTask();
        });
    }
    _startAnimationTask() {
        return __awaiter(this, void 0, void 0, function* () {
            let index = 0;
            let descAction = true;
            const animFunc = () => {
                let stat = this._statsViews[index];
                if (descAction) {
                    descAction = false;
                    stat.ctrls.lText.addClass('hidden');
                    stat.ctrls.lDescription.removeClass('hidden');
                    setTimeout(animFunc, 6000);
                }
                else {
                    descAction = true;
                    stat.ctrls.lText.removeClass('hidden');
                    stat.ctrls.lDescription.addClass('hidden');
                    index++;
                    if (index >= this._statsViews.length)
                        index = 0;
                    stat = this._statsViews[index];
                    setTimeout(animFunc, 1000);
                }
            };
            animFunc();
        });
    }
    _ethToFormat(eth, del = 3) { return this.app.chain.ethToFormat(eth, del); }
}
exports.StateDashboard = StateDashboard;
StateDashboard.StateName = "dashboard";
//# sourceMappingURL=StateDashboard.js.map